var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpressCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#45355C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.931 21.74c-.896-.17-2.325.49-2.325.49a.6.6 0 01-.698-.002 12.274 12.274 0 01-2.551-2.512c-.958-1.289-1.376-2.669-1.54-3.376a.58.58 0 01.186-.571l1.041-.898a1.3 1.3 0 00.443-1.156l-.475-3.624a1.232 1.232 0 00-.615-.915 1.267 1.267 0 00-1.1-.09c-1.254.478-3.393 1.648-3.632 4.11-.353 3.593 2.634 7.89 2.76 8.068.115.17 2.852 4.173 6.476 5.45a4.87 4.87 0 001.624.286c1.723 0 3.03-.978 3.74-1.673a1.22 1.22 0 00.37-.942 1.25 1.25 0 00-.484-.911l-.323-.25c-1.875-1.309-2.001-1.313-2.897-1.483z",
    fill: "#fff"
  })));
}
export default SvgExpressCare;